<template>
  <v-snackbar
    v-model="snackbarInfo.status"
    :color="snackbarInfo.color"
    top
    dark
  >
    <v-icon color="white" class="mr-3">
      {{ snackbarInfo.icon }}
    </v-icon>
    <span v-text="snackbarInfo.msg"></span>
    <v-icon size="16" color="white" @click="snackbarInfo.status = false">
      mdi-close-circle
    </v-icon>
  </v-snackbar>
</template>

<script>
// loading 通知加载组件
export default {
  name: "toast",
  props: {
    snackbarInfo: {
      status: false,
      color: "",
      msg: "",
      icon: "",
    },
  },
};
</script>

<style scoped></style>
